import * as React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";
import type { ObjValidatorProps } from "interfaces/shared.types";

const Homepage = Scrivito.connect((props: ObjValidatorProps) => (
  <ObjValidator {...props}>{<div data-testid="homepage" />}</ObjValidator>
));

export default Homepage;
Scrivito.provideComponent("Homepage", Homepage);
